<template>
  <div class="page-header">
    <h3 class="title">{{ title }}</h3>
    <h5>
      <template v-for="(text, index) in parsedSubTitle" :key="index">
        <span>{{ text }}</span><br v-if="index < parsedSubTitle.length - 1">
      </template>
    </h5>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    parsedSubTitle() {
      const separators = /<br\s*\/?>|\bbr\b|\n/gi;
      return this.subTitle.split(separators).filter(line => line.trim() !== '');
    }
  }
}
</script>
<style lang="scss">
$Gray-10: #F1F2F3;
$Gray-20: #e8ebed;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$Yellow: #ffe414;
$CertiBlue : #278AEC;

.page-header {
  width: 100%;
  margin-bottom: 24px !important;

  h5 {
      color: $Gray-70;
      font-weight: 400;
      font-size: 14px;
  }

  h3 {
      color: #2F3337;
      font-size: 24px;
      font-family: 'SuitBold';
  }

  span {
    color: #6e747c;
  }
}
</style>